"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m11.875 8.224-.713.7-.833-.846v6.053a.5.5 0 0 1-.5.5H6.753a.5.5 0 0 1-.5-.5v-1.936H5.29v-1h1.462c.277 0 .5.223.5.5v1.936h2.076V7.06L6.007 3.685 2.519 7.23v6.4H5.29v1H2.019a.5.5 0 0 1-.5-.5V8.248l-.666.677-.713-.701 5.51-5.602a.514.514 0 0 1 .714 0l2.965 3.013v-1.22h-.89v-1h1.39a.5.5 0 0 1 .5.5v2.737l1.546 1.572Zm.835 3.898a2.233 2.233 0 0 1 1.03-.26 2.257 2.257 0 0 1 2.256 2.254h-1a1.256 1.256 0 0 0-2.511 0h-1c0-.47.147-.908.395-1.27-.106-.58-.592-1.034-1.203-1.039l.008-1a2.257 2.257 0 0 1 2.025 1.315Zm-8.903-2.56h1V8.317h-1v1.247Zm4.065 0h-1V8.317h1v1.247Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m17.689 11.64-.802.79-1.625-1.654v9.772c0 .31-.252.563-.563.563H9.988a.563.563 0 0 1-.563-.563v-3.17H7.747v-1.124h2.24c.311 0 .563.252.563.562v3.17h3.587V9.633l-5.292-5.38-5.55 5.641v10.092h4.452v1.125H2.733a.563.563 0 0 1-.563-.563v-9.51L.802 12.43 0 11.64l8.444-8.583a.58.58 0 0 1 .802 0l4.89 4.972V5.46h-1.565V4.336h2.128c.31 0 .563.25.563.562v4.276l2.427 2.467Zm1.326 6.116a3.225 3.225 0 0 1 1.679-.48 3.256 3.256 0 0 1 3.252 3.251H22.82a2.13 2.13 0 0 0-2.127-2.127 2.13 2.13 0 0 0-2.128 2.127H17.44c0-.72.243-1.38.64-1.918A2.128 2.128 0 0 0 16 16.785l.008-1.125c1.372.01 2.54.883 3.006 2.096ZM5.678 13.55h1.125v-1.91H5.678v1.91Zm6.277 0H10.83v-1.91h1.125v1.91Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m23.585 15.52-1.069 1.053-2.167-2.204v13.029a.75.75 0 0 1-.75.75h-6.282a.75.75 0 0 1-.75-.75v-4.226h-2.238v-1.5h2.988a.75.75 0 0 1 .75.75v4.226h4.782V12.844l-7.056-7.172-7.399 7.52v13.456h5.935v1.5H3.644a.75.75 0 0 1-.75-.75v-12.68l-1.825 1.855L0 15.52 11.258 4.077a.772.772 0 0 1 1.07 0l6.521 6.629V7.28h-2.088v-1.5h2.838a.75.75 0 0 1 .75.75v5.7l3.236 3.29Zm1.768 8.154a4.3 4.3 0 0 1 2.239-.64 4.34 4.34 0 0 1 4.336 4.335h-1.5a2.839 2.839 0 0 0-2.836-2.835 2.84 2.84 0 0 0-2.837 2.835h-1.5c0-.96.324-1.838.854-2.558a2.837 2.837 0 0 0-2.774-2.43l.01-1.5c1.83.014 3.387 1.177 4.008 2.793ZM7.57 18.069h1.5V15.52h-1.5v2.547Zm8.37 0h-1.5V15.52h1.5v2.547Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m35.413 23.414-1.337 1.315-3.619-3.679v20.199a.938.938 0 0 1-.937.938h-9.507a.938.938 0 0 1-.938-.938v-6.594h-3.583V32.78h4.521c.517 0 .938.42.938.938v6.593h7.631V19.145L17.707 8.09 6.313 19.67v20.64h9.179v1.876H5.375a.938.938 0 0 1-.937-.938V21.576l-3.1 3.153L0 23.414l17.038-17.32a.966.966 0 0 1 1.337 0L28.582 16.47v-5.866h-3.357V8.73h4.295c.518 0 .938.42.938.937v8.71l4.955 5.037Zm2.717 12.474a6.326 6.326 0 0 1 3.487-1.046 6.373 6.373 0 0 1 6.365 6.365h-1.875a4.496 4.496 0 0 0-4.49-4.49 4.496 4.496 0 0 0-4.49 4.49H35.25c0-1.448.492-2.78 1.31-3.852a4.5 4.5 0 0 0-4.412-3.897l.015-1.875c2.762.021 5.11 1.824 5.966 4.305ZM11.514 27.13h1.875v-3.856h-1.875v3.856Zm12.344 0h-1.875v-3.856h1.875v3.856Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m47.217 31.219-1.782 1.753-4.825-4.905v26.932c0 .69-.559 1.25-1.25 1.25H26.684c-.69 0-1.25-.56-1.25-1.25v-8.792h-4.778v-2.5h6.028c.69 0 1.25.56 1.25 1.25v8.792H38.11V25.526L23.609 10.785 8.417 26.228v27.52h12.239v2.5H7.167c-.69 0-1.25-.56-1.25-1.25v-26.23l-4.134 4.204L0 31.219 22.718 8.125c.469-.477 1.312-.477 1.782 0L38.11 21.96v-7.82h-4.476v-2.5h5.726c.691 0 1.25.56 1.25 1.25v11.613l6.607 6.716ZM50.84 47.85a8.435 8.435 0 0 1 4.649-1.395c4.68 0 8.487 3.808 8.487 8.487h-2.5a5.994 5.994 0 0 0-5.987-5.987 5.994 5.994 0 0 0-5.987 5.987h-2.5c0-1.93.655-3.708 1.746-5.136-.386-2.906-2.874-5.173-5.883-5.196l.02-2.5c3.683.028 6.814 2.432 7.955 5.74ZM15.352 36.173h2.5v-5.14h-2.5v5.14Zm16.458 0h-2.5v-5.14h2.5v5.14Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSingleFamily = function IconSingleFamily(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Single Family' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "SingleFamily"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSingleFamily.sizes = [16, 24, 32, 48, 64];
IconSingleFamily.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSingleFamily;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/renters/SingleFamily.js
// module id = 2289
// module chunks = 0